import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue'
import { ref, withDefaults } from 'vue'

interface PropsType {
  isPdf: boolean
  tagList: any[]
  values: any[]
  idKey: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-data-tag',
  props: {
    isPdf: { type: Boolean },
    tagList: { default: () => [] },
    values: null,
    idKey: { default: '' }
  },
  emits: ['onChange'],
  setup(__props: any, { emit: emits }) {

const props = __props as { isPdf: boolean, tagList: any[], values: any[], idKey: string }





const dragIndex = ref<number | null>(null)
const targetTagList = ref<any[]>([])

function handleCheckSourceTag(e: Event) {
  if ((e.target as any)?.checked) {
    targetTagList.value.push(
      ...props.tagList.filter((item) => item.key == (e.target as any)?.value)
    )
  } else {
    targetTagList.value = targetTagList.value.filter(
      (item) => item.key != (e.target as any)?.value
    )
  }
  emits(
    'onChange',
    targetTagList.value.map((item) => item.key)
  )
}

function handleDragStartTag(index: number) {
  dragIndex.value = index
}

function handleDragEndTag() {
  dragIndex.value = null
  emits(
    'onChange',
    targetTagList.value.map((item) => item.key)
  )
}

function handleDragOverTag(index: number) {
  if (dragIndex.value === null) return

  if (dragIndex.value !== index) {
    const newTargetTagList = [...targetTagList.value]
    const dragItem = newTargetTagList.splice(dragIndex.value, 1)[0]
    newTargetTagList.splice(index, 0, dragItem)
    targetTagList.value = newTargetTagList
    dragIndex.value = index
  }
}

function handleDelTarget(key: string) {
  targetTagList.value = targetTagList.value.filter((item) => item.key != key)
  emits(
    'onChange',
    targetTagList.value.map((item) => item.key)
  )
}

watch(
  () => props.values,
  (val: string[]) => {
    const tempTagList: any[] = []
    val.forEach((key) => {
      const tagItem = props.tagList.find((item) => item.key == key)
      tempTagList.push(tagItem)
    })
    targetTagList.value = tempTagList
  },
  {
    immediate: true,
  }
)

return { __sfc: true,props, emits, dragIndex, targetTagList, handleCheckSourceTag, handleDragStartTag, handleDragEndTag, handleDragOverTag, handleDelTarget }
}

})